export const V1_LICENSE_TO_CATALOGUE_ID_MAP = new Map([
    [1, 1],
    [2, 2],
    [3, 3],
    [4, 4],
    [5, 5],
    [6, 6],
    [7, 7],
    [8, 8],
    [9, 9],
    [10, 10],
    [11, 11],
    [12, 12],
    [25, 13],
    [26, 14],
    [27, 15],
    [28, 16],
    [29, 17],
    [30, 18],
    [31, 19],
    [32, 20],
    [33, 21],
    [34, 22],
    [35, 23],
    [36, 24],
    [55, 25],
    [56, 26],
    [57, 27],
    [58, 28],
    [70, 29],
    [71, 30],
    [72, 31],
    [73, 32],
    [74, 33],
    [75, 34],
    [76, 35],
    [77, 36],
    [78, 37],
    [79, 38],
    [80, 39],
    [81, 40],
    [109, 41],
    [110, 42],
    [111, 43],
    [112, 44],
    [113, 45],
    [114, 46],
    [115, 47],
    [116, 48],
    [117, 49],
    [118, 50],
    [119, 51],
    [120, 52],
    [121, 53],
    [122, 54],
    [123, 55],
    [124, 56],
    [125, 57],
    [126, 58],
    [127, 59],
    [128, 60],
    [129, 61],
    [151, 62],
    [152, 63],
    [153, 64],
    [154, 65],
    [155, 66],
    [156, 67],
    [157, 68],
    [158, 69],
    [159, 70],
    [160, 71],
    [161, 72],
    [162, 73],
    [163, 74],
    [164, 75],
    [165, 76],
    [166, 77],
    [167, 78],
    [168, 79],
    [169, 80],
    [170, 81],
    [171, 82],
    [218, 83],
    [219, 84],
    [220, 85],
    [221, 86],
    [472, 87],
    [473, 88],
    [474, 89],
    [496, 90],
    [497, 91],
    [498, 92],
    [499, 93],
    [500, 94],
    [501, 95],
    [502, 96],
    [940, 97],
    [941, 98],
    [942, 99],
    [943, 100],
    [944, 101],
    [945, 102],
    [946, 103],
    [947, 104],
    [948, 105],
    [949, 106],
    [950, 107],
    [951, 108],
    [952, 109],
    [953, 110],
    [954, 111],
    [955, 112],
    [956, 113],
    [957, 114],
    [958, 115],
    [959, 116],
    [960, 117],
    [961, 118],
    [962, 119],
    [963, 120],
    [964, 121],
    [965, 122],
    [966, 123],
    [967, 124],
    [968, 125],
    [969, 126],
    [970, 127],
    [971, 128],
    [972, 129],
    [973, 130],
    [974, 131],
    [975, 132],
    [976, 133],
    [977, 134],
    [978, 135],
    [979, 136],
    [980, 137],
    [981, 138],
    [982, 139],
    [983, 140],
    [984, 141],
    [985, 142],
    [986, 143],
    [987, 144],
    [988, 145],
    [989, 146],
    [990, 147],
    [991, 148],
    [992, 149],
    [993, 150],
    [994, 151],
    [995, 152],
    [996, 153],
    [997, 154],
    [998, 155],
    [999, 156],
    [1000, 157],
    [1001, 158],
    [1002, 159],
    [1003, 160],
    [1004, 161],
    [1005, 162],
    [1006, 163],
    [1007, 164],
    [1008, 165],
    [1009, 166],
    [1010, 167],
    [1011, 168],
    [1013, 169],
    [1014, 170],
    [1015, 171],
    [1016, 172],
    [1017, 173],
    [1018, 174],
    [1019, 175],
    [1020, 176],
    [1021, 177],
    [1022, 178],
    [1023, 179],
    [1024, 180],
    [1025, 181],
    [1026, 182],
    [1027, 183],
    [1028, 184],
    [1029, 185],
    [1030, 186],
    [1031, 187],
    [1032, 188],
    [1033, 189],
    [1034, 190],
    [49, 191],
    [50, 192],
    [51, 193],
    [97, 194],
    [98, 195],
    [99, 196],
    [106, 197],
    [107, 198],
    [108, 199],
    [193, 200],
    [194, 201],
    [195, 202],
    [196, 203],
    [197, 204],
    [198, 205],
    [205, 206],
    [206, 207],
    [207, 208],
    [208, 209],
    [209, 210],
    [210, 211],
    [222, 212],
    [223, 213],
    [224, 214],
    [232, 215],
    [233, 216],
    [234, 217],
    [235, 218],
    [236, 219],
    [237, 220],
    [247, 221],
    [248, 222],
    [249, 223],
    [250, 224],
    [251, 225],
    [252, 226],
    [253, 227],
    [254, 228],
    [255, 229],
    [265, 230],
    [266, 231],
    [267, 232],
    [273, 233],
    [275, 234],
    [276, 235],
    [277, 236],
    [278, 237],
    [290, 238],
    [407, 239],
    [408, 240],
    [470, 241],
    [471, 242],
    [752, 243],
    [753, 244],
    [754, 245],
    [755, 246],
    [902, 247],
    [903, 248],
    [904, 249],
    [905, 250],
    [906, 251],
    [907, 252],
    [908, 253],
    [921, 254],
    [922, 255],
    [923, 256],
    [924, 257],
    [925, 258],
    [926, 259],
    [927, 260],
    [928, 261],
    [929, 262],
    [930, 263],
    [931, 264],
    [932, 265],
    [933, 266],
    [934, 267],
    [935, 268],
    [936, 269],
    [937, 270],
    [938, 271],
    [939, 272],
    [1012, 273],
    [284, 274],
    [285, 275],
    [286, 276],
    [287, 277],
    [382, 278],
    [386, 279],
    [390, 280],
    [394, 281],
    [398, 282],
    [399, 283],
    [400, 284],
    [401, 285],
    [402, 286],
    [403, 287],
    [404, 288],
    [405, 289],
    [406, 290],
    [413, 291],
    [414, 292],
    [458, 293],
    [459, 294],
    [460, 295],
    [461, 296],
    [462, 297],
    [463, 298],
    [464, 299],
    [465, 300],
    [466, 301],
    [467, 302],
    [415, 303],
    [416, 304],
    [515, 305],
    [516, 306],
    [517, 307],
    [518, 308],
    [519, 309],
    [520, 310],
    [521, 311],
    [522, 312],
    [523, 313],
    [524, 314],
    [756, 315],
    [757, 316],
    [758, 317],
    [759, 318],
    [760, 319],
    [761, 320],
    [762, 321],
    [763, 322],
    [764, 323],
    [765, 324],
    [766, 325],
    [767, 326],
    [768, 327],
    [769, 328],
    [770, 329],
    [771, 330],
    [772, 331],
    [773, 332],
    [774, 333],
    [775, 334],
    [776, 335],
    [777, 336],
    [778, 337],
    [779, 338],
    [780, 339],
    [781, 340],
    [782, 341],
    [783, 342],
    [784, 343],
    [785, 344],
    [786, 345],
    [787, 346],
    [788, 347],
    [789, 348],
    [790, 349],
    [791, 350],
    [792, 351],
    [793, 352],
    [794, 353],
    [795, 354],
    [796, 355],
    [797, 356],
    [798, 357],
    [799, 358],
    [800, 359],
    [801, 360],
    [802, 361],
    [803, 362],
    [804, 363],
    [805, 364],
    [806, 365],
    [807, 366],
    [808, 367],
    [809, 368],
    [810, 369],
    [811, 370],
    [812, 371],
    [813, 372],
    [814, 373],
    [815, 374],
    [816, 375],
    [817, 376],
    [818, 377],
    [819, 378],
    [820, 379],
    [821, 380],
    [822, 381],
    [823, 382],
    [824, 383],
    [825, 384],
    [826, 385],
    [827, 386],
    [828, 387],
    [829, 388],
    [830, 389],
    [831, 390],
    [832, 391],
    [833, 392],
    [834, 393],
    [835, 394],
    [836, 395],
    [837, 396],
    [838, 397],
    [839, 398],
    [840, 399],
    [841, 400],
    [842, 401],
    [843, 402],
    [844, 403],
    [845, 404],
    [846, 405],
    [847, 406],
    [848, 407],
    [849, 408],
    [850, 409],
    [851, 410],
    [852, 411],
    [853, 412],
    [854, 413],
    [855, 414],
    [856, 415],
    [857, 416],
    [858, 417],
    [859, 418],
    [860, 419],
    [861, 420],
    [862, 421],
    [863, 422],
    [864, 423],
    [865, 424],
    [866, 425],
    [867, 426],
    [868, 427],
    [869, 428],
    [870, 429],
    [871, 430],
    [872, 431],
    [873, 432],
    [874, 433],
    [875, 434],
    [876, 435],
    [877, 436],
    [878, 437],
    [879, 438],
    [880, 439],
    [881, 440],
    [882, 441],
    [883, 442],
    [884, 443],
    [885, 444],
    [886, 445],
    [887, 446],
    [888, 447],
    [889, 448],
    [890, 449],
    [891, 450],
    [892, 451],
    [893, 452],
    [894, 453],
    [895, 454],
    [896, 455],
    [899, 456],
    [900, 457],
    [901, 458],
    [909, 459],
    [910, 460],
    [911, 461],
    [912, 462],
    [913, 463],
    [914, 464],
    [915, 465],
    [916, 466],
    [917, 467],
    [918, 468],
    [919, 469],
    [920, 470],
    [503, 471],
    [504, 472],
    [505, 473],
    [506, 474],
    [507, 475],
    [508, 476],
    [509, 477],
    [510, 478],
    [511, 479],
    [512, 480],
    [513, 481],
    [514, 482],
    [525, 483],
    [528, 484],
    [749, 485],
    [750, 486],
    [751, 487],
    [529, 488],
    [530, 489],
    [531, 490],
    [532, 491],
    [533, 492],
    [534, 493],
    [535, 494],
    [536, 495],
    [537, 496],
    [538, 497],
    [539, 498],
    [540, 499],
    [541, 500],
    [542, 501],
    [543, 502],
    [544, 503],
    [545, 504],
    [546, 505],
    [547, 506],
    [548, 507],
    [549, 508],
    [550, 509],
    [551, 510],
    [552, 511],
    [553, 512],
    [554, 513],
    [555, 514],
    [556, 515],
    [557, 516],
    [558, 517],
    [559, 518],
    [560, 519],
    [561, 520],
    [562, 521],
    [563, 522],
    [564, 523],
    [565, 524],
    [566, 525],
    [567, 526],
    [568, 527],
    [569, 528],
    [570, 529],
    [571, 530],
    [572, 531],
    [573, 532],
    [574, 533],
    [575, 534],
    [576, 535],
    [577, 536],
    [578, 537],
    [579, 538],
    [580, 539],
    [581, 540],
    [582, 541],
    [583, 542],
    [584, 543],
    [585, 544],
    [586, 545],
    [587, 546],
    [588, 547],
    [589, 548],
    [590, 549],
    [591, 550],
    [592, 551],
    [593, 552],
    [594, 553],
    [595, 554],
    [596, 555],
    [597, 556],
    [598, 557],
    [599, 558],
    [600, 559],
    [601, 560],
    [602, 561],
    [603, 562],
    [604, 563],
    [605, 564],
    [606, 565],
    [607, 566],
    [608, 567],
    [609, 568],
    [610, 569],
    [611, 570],
    [612, 571],
    [613, 572],
    [614, 573],
    [615, 574],
    [616, 575],
    [617, 576],
    [618, 577],
    [619, 578],
    [620, 579],
    [621, 580],
    [622, 581],
    [623, 582],
    [624, 583],
    [625, 584],
    [626, 585],
    [627, 586],
    [628, 587],
    [629, 588],
    [630, 589],
    [631, 590],
    [632, 591],
    [633, 592],
    [634, 593],
    [635, 594],
    [636, 595],
    [637, 596],
    [638, 597],
    [639, 598],
    [640, 599],
    [641, 600],
    [642, 601],
    [643, 602],
    [644, 603],
    [645, 604],
    [646, 605],
    [647, 606],
    [648, 607],
    [649, 608],
    [650, 609],
    [651, 610],
    [652, 611],
    [653, 612],
    [654, 613],
    [655, 614],
    [656, 615],
    [657, 616],
    [658, 617],
    [659, 618],
    [660, 619],
    [661, 620],
    [662, 621],
    [663, 622],
    [664, 623],
    [665, 624],
    [666, 625],
    [667, 626],
    [668, 627],
    [669, 628],
    [670, 629],
    [671, 630],
    [672, 631],
    [673, 632],
    [674, 633],
    [675, 634],
    [676, 635],
    [677, 636],
    [678, 637],
    [679, 638],
    [680, 639],
    [681, 640],
    [682, 641],
    [683, 642],
    [684, 643],
    [685, 644],
    [686, 645],
    [687, 646],
    [688, 647],
    [689, 648],
    [690, 649],
    [691, 650],
    [692, 651],
    [693, 652],
    [694, 653],
    [695, 654],
    [696, 655],
    [697, 656],
    [698, 657],
    [699, 658],
    [700, 659],
    [701, 660],
    [702, 661],
    [703, 662],
    [704, 663],
    [705, 664],
    [706, 665],
    [707, 666],
    [708, 667],
    [709, 668],
    [710, 669],
    [711, 670],
    [712, 671],
    [713, 672],
    [714, 673],
    [715, 674],
    [716, 675],
    [717, 676],
    [718, 677],
    [719, 678],
    [720, 679],
    [721, 680],
    [722, 681],
    [723, 682],
    [724, 683],
    [725, 684],
    [726, 685],
    [727, 686],
    [728, 687],
    [729, 688],
    [730, 689],
    [731, 690],
    [732, 691],
    [733, 692],
    [734, 693],
    [735, 694],
    [736, 695],
    [737, 696],
    [738, 697],
    [739, 698],
    [740, 699],
    [741, 700],
    [742, 701],
    [743, 702],
    [744, 703],
    [745, 704],
    [746, 705],
    [747, 706],
    [748, 707],
    [1039, 708],
    [1040, 709],
    [1041, 710],
    [1042, 711],
    [1043, 712],
    [1044, 713],
    [1045, 714],
    [1046, 715],
    [1047, 716],
    [1048, 717],
    [1049, 718],
    [1050, 719],
    [1051, 720],
    [1052, 721],
    [1053, 722],
    [1054, 723],
    [1055, 724],
    [1056, 725],
    [1057, 726],
    [1058, 727],
    [1059, 728],
    [1060, 729],
    [1061, 730],
    [1062, 731],
    [1063, 732],
    [1064, 733],
    [1065, 734],
    [1066, 735],
    [1067, 736],
    [1068, 737],
    [1069, 738],
    [1070, 739],
    [1071, 740],
    [1072, 741],
    [1073, 742],
    [1074, 743],
    [1075, 744],
    [1076, 745],
    [1077, 746],
    [1078, 747],
    [1079, 748],
    [1080, 749],
    [1081, 750],
    [1082, 751],
    [1083, 752],
    [1084, 753],
    [1085, 754],
    [1086, 755],
    [1087, 756],
    [1088, 757],
    [1089, 758],
    [1090, 759],
    [1091, 760],
    [1092, 761],
    [1093, 762],
    [1094, 763],
    [1095, 764],
    [1096, 765],
    [1097, 766],
    [1098, 767],
    [1099, 768],
    [1100, 769],
    [1101, 770],
    [1102, 771],
    [1103, 772],
    [1104, 773],
    [1105, 774],
    [1106, 775],
    [1107, 776],
    [1108, 777],
    [1109, 778],
    [1110, 779],
]);

export const mapV1LicenseIdToCatalogueId = (v1Id) => {
    const parsedId = Number(v1Id);
    if (!Number.isFinite(parsedId)) return null;
    return V1_LICENSE_TO_CATALOGUE_ID_MAP.get(parsedId) ?? null;
};

export const V1_UNITCOST_TO_CATALOGUE_ID_MAP = new Map([
    [1, 780],
    [2, 781],
    [4, 782],
    [5, 783],
    [6, 784],
    [7, 785],
    [8, 786],
    [9, 787],
    [13, 788],
    [14, 789],
    [15, 790],
    [16, 791],
    [17, 792],
    [18, 793],
    [19, 794],
    [20, 795],
    [28, 796],
    [47, 2328], /* ICON Portal > Maintel Portal */
    [49, 797],
    [136, 798],
    [157, 799],
    [169, 800],
    [170, 801],
    [172, 802],
    [191, 803],
    [192, 804],
    [193, 805],
    [27, 806],
    [69, 807],
    [70, 808],
    [71, 809],
    [77, 810],
    [78, 811],
    [79, 812],
    [90, 813],
    [93, 814],
    [94, 815],
    [95, 816],
    [96, 817],
    [97, 818],
    [98, 819],
    [99, 820],
    [100, 821],
    [101, 822],
    [116, 823],
    [117, 824],
    [118, 825],
    [119, 826],
    [120, 827],
    [121, 828],
    [122, 829],
    [123, 830],
    [124, 831],
    [125, 832],
    [126, 833],
    [127, 834],
    [128, 835],
    [129, 836],
    [130, 837],
    [131, 838],
    [132, 839],
    [133, 840],
    [134, 841],
    [135, 842],
    [137, 843],
    [143, 844],
    [144, 845],
    [145, 846],
    [146, 847],
    [147, 848],
    [148, 849],
    [149, 850],
    [150, 851],
    [151, 852],
    [152, 853],
    [153, 854],
    [158, 855],
    [159, 856],
    [160, 857],
    [171, 858],
    [185, 859],
    [188, 860],
    [189, 861],
    [194, 862],
    [195, 863],
    [196, 864],
    [197, 865],
    [198, 866],
    [199, 867],
    [200, 868],
    [201, 869],
    [202, 870],
    [203, 871],
    [50, 872],
    [51, 873],
    [52, 874],
    [53, 875],
    [54, 876],
    [55, 877],
    [56, 878],
    [57, 879],
    [58, 880],
    [59, 881],
    [60, 882],
    [61, 883],
    [105, 884],
    [107, 885],
    [109, 886],
    [110, 887],
    [111, 888],
    [112, 889],
    [113, 890],
    [141, 891],
    [142, 892],
    [164, 893],
    [165, 894],
    [139, 895],
    [162, 896],
    [163, 897],
    [173, 898],
    [174, 899],
    [175, 900],
    [176, 901],
    [177, 902],
    [178, 903],
    [179, 904],
    [180, 905],
    [183, 906],
    [184, 907],
    [190, 908],
]);

export const mapV1UnitCostIdToCatalogueId = (v1Id) => {
    const parsedId = Number(v1Id);
    if (!Number.isFinite(parsedId)) return null;
    return V1_UNITCOST_TO_CATALOGUE_ID_MAP.get(parsedId) ?? null;
};

